
import { PRIMARY_COLOR, SECONDARY_COLOR } from "./constants";
import { ThemeConfig } from "antd";

export const theme = {
    hashed: false,
    token: {
        colorPrimary: PRIMARY_COLOR,
        colorFillSecondary: SECONDARY_COLOR,
        colorTextSecondary: SECONDARY_COLOR,
        colorBorderSecondary: SECONDARY_COLOR,
        colorBgContainer: '#fff',
        colorLink: PRIMARY_COLOR,
        borderRadius: 10,
        colorTextHeading: PRIMARY_COLOR,
        colorWarning: SECONDARY_COLOR,
        fontFamily: 'AvenirNext LT Pro',
        fontSize: 16,
        fontSizeSM: 14,
        fontSizeLG: 18,
        fontSizeXL: 20,
        fontWeightStrong: 500,
        fontSizeHeading1: 48,
        fontSizeHeading2: 32,
        fontSizeHeading3: 24,
        fontSizeHeading4: 20,
        fontSizeHeading5: 18,            
    },

    components: {
        Layout: {
            headerBg: '#fff',
            footerBg: '#143f76',
            footerPadding: 0,
        },
        Button: {
            defaultActiveColor: SECONDARY_COLOR,
            defaultActiveBorderColor: SECONDARY_COLOR,
            defaultHoverBorderColor: SECONDARY_COLOR,
            defaultHoverColor: SECONDARY_COLOR,
            borderRadius: 5,
            borderRadiusLG: 6,
            borderRadiusSM: 4,
            defaultShadow: 'none',
            primaryShadow: 'none',
            dangerShadow: 'none',
        },
        Typography: {         
            titleMarginTop: '1rem',   
        },
        Card: {
            headerFontSize: 19,
            headerHeight: 60,
        },
        Result: {
            titleFontSize: 32,
        }
    }
} as ThemeConfig

